const CHUNK_RELOAD_KEY = 'mb_chunk_reload_attempted';

const isChunkLoadError = (error) => {
  const message = `${error?.message || ''}`.toLowerCase();
  const name = `${error?.name || ''}`.toLowerCase();
  return (
    name.includes('chunkloaderror') ||
    message.includes('loading chunk') ||
    message.includes('failed to fetch dynamically imported module')
  );
};

const lazyRetry = (importer) =>
  new Promise((resolve, reject) => {
    importer()
      .then((module) => {
        if (typeof window !== 'undefined') {
          window.sessionStorage.removeItem(CHUNK_RELOAD_KEY);
        }
        resolve(module);
      })
      .catch((error) => {
        if (typeof window === 'undefined' || !isChunkLoadError(error)) {
          reject(error);
          return;
        }

        const alreadyReloaded = window.sessionStorage.getItem(CHUNK_RELOAD_KEY) === 'true';
        if (alreadyReloaded) {
          window.sessionStorage.removeItem(CHUNK_RELOAD_KEY);
          reject(error);
          return;
        }

        window.sessionStorage.setItem(CHUNK_RELOAD_KEY, 'true');
        window.location.reload();
      });
  });

export default lazyRetry;
